<template>
    <search-input
        ref="searchInput"
        v-model="user"
        autoSearch
        :finished="finished"
        finished-text="没有更多了"
        :loading="loading"
        :queryWhenInput="false"
        @load="onQuery"
        @onChange="onQuery(true)">
        <div
            @click="handleRightBtn"
            slot="rightBtn">搜索</div>
        <div
            class="userInfo" v-for="item in userInfoList" :key="item.value"
            @click="onItemClick(item)">
            <div class="info-wrap">
                <div class="name">
                    <span class="user-name">{{ item.employeeName }}</span>
                </div>
                <div class="usercode">
                    {{ item.employeeCode }}
                </div>
            </div>
            <div :title="item.deptName" class="dept">{{ item.officeName }}</div>
        </div>
    </search-input>
</template>
<script>
import { BaseService } from '@/network'
export default {
    name: 'search',
    data() {
        return {
            userInfoList: [],
            user: '',
            loading: false,
            finished: false,
        }
    },
    methods: {
        onQuery(isReset) {
            if (this.query === '') {
                this.userInfoList = []
                return
            }
            if (isReset) {
                this.userInfoList = []
            }
            this.loading = true
            let data = {
                keyword: this.user,
                pageNum: 1,
                pageSize: 10,
            }
            BaseService.getUsers(data).then((res) => {
                const { data: { data: { list } } } = res
                this.userInfoList = list
                this.loading = false
                this.finished = true
            })
        },
        onClear() {
            this.userInfoList = []
            this.loading = false
            this.finished = false
        },
        handleRightBtn() {
            this.$refs.searchInput.doSearch()
        },
        onItemClick(item) {
            this.$emit('getUser', item)
        },
    }
}
</script>
<style scoped lang="scss">
    .userInfo {
        padding: 4px 0 5px 10px;
        margin-bottom: 8px;
        list-style: none;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 400;
        color: #424B58;
        line-height: 20px;
        cursor: pointer;
        color: #9298A8;
        .info-wrap{
            display: flex;
        }
        .usercode{
            // flex:1;
            text-align:right;
            padding-right:8px;
            box-sizing: border-box;
        }
        .name{
            flex:1;
            .user-name{
                height: 14px;
                font-size: 14px;
                font-weight: 400;
                color: #424b58;
            }
        }
        .persion-item{
            display: block;
        }
        .dept{
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 244px;
            overflow: hidden;
        }
    }
</style>